<template>
   <div class="row">
      <div id="search-nav" class="col-12 d-block btn-group dropup">
         <button type="button" class="btn btn-primary dropdown-toggle d-block d-lg-none" :class="pesquisa.resultado.length > 0 ? '' : 'empty'" data-toggle="dropdown" aria-expanded="false">
            <i class="far fa-search font-17"></i>
         </button>
         <div class="card mb-2 dropdown-menu dropdown-menu-left">
            <div class="card-body pb-0">
               <div class="row m-0">
                  <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                     <label><i class="far fa-filter font-13 color-theme mr-1"></i> Tipo de pesquisa</label>
                     <v-select class="rounded" title="Desktop" :options="['Nome sentenciado', 'Nº Documento de Identificação', 'Data', 'Nome entidade']" v-model="pesquisa.tipo" />
                     <select title="Mobile" class="form-control rounded" v-model="pesquisa.tipo">
                        <option v-for="(option, index) in ['Nome sentenciado', 'Nº Documento de Identificação', 'Data', 'Nome entidade']" :key="index" :value="option">{{ option }}</option>
                     </select>
                  </div>
                  <div class="col-12 col-sm-6 col-md-5 mb-3 px-1" v-if="pesquisa.tipo == 'Nº Documento de Identificação'">
                     <label><i class="far fa-hashtag font-13 color-theme mr-1"></i> Nº Identificação</label>
                     <input type="text" class="form-control rounded" v-model="pesquisa.docIdentificacao" maxlength="200" @keyup.enter="buscarApenados" />
                  </div>
                  <div class="col-12 col-sm-6 col-md-5 px-0" v-else-if="pesquisa.tipo == 'Data'">
                     <div class="row m-0">
                        <div class="col-6 mb-3 px-1">
                           <label><i class="far fa-calendar color-theme font-13 mr-1"></i> Data inicial</label>
                           <datePicker title="Desktop" :format="'dd/MM/yyyy'" :language="ptBR" v-model="pesquisa.dataInicial"></datePicker>
                           <input title="Mobile" class="form-control" type="date" v-model="pesquisa.dataInicial" />
                        </div>
                        <div class="col-6 mb-3 px-1">
                           <label><i class="far fa-calendar color-theme font-13 mr-1"></i> Data final</label>
                           <datePicker title="Desktop" :format="'dd/MM/yyyy'" :language="ptBR" v-model="pesquisa.dataFinal"></datePicker>
                           <input title="Mobile" class="form-control" type="date" v-model="pesquisa.dataFinal" />
                        </div>
                     </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-5 mb-3 px-1" v-else-if="pesquisa.tipo == 'Nome entidade'">
                     <label><i class="far fa-building font-13 color-theme mr-1"></i> Nome entidade</label>
                     <input type="text" class="form-control rounded" v-model="pesquisa.nomeEntidade" maxlength="200" @keyup.enter="buscarServicos" />
                  </div>
                  <div class="col-12 col-sm-6 col-md-5 mb-3 px-1" v-else>
                     <label><i class="far fa-user font-13 color-theme mr-1"></i> Nome sentenciado</label>
                     <input type="text" class="form-control rounded" v-model="pesquisa.nomeApenado" maxlength="200" @keyup.enter="buscarServicos" />
                  </div>
                  <div class="col-5 col-sm-6 col-md-1 mb-3 px-1 align-self-end">
                     <button type="button" class="btn btn-primary w-100 rounded" @click="buscarServicos">
                        <i class="fa fa-search font-13"></i>
                     </button>
                  </div>
                  <div class="col-7 col-sm-6 col-md-2 mb-3 px-1 align-self-end">
                     <button type="button" class="btn btn-primary w-100 rounded" @click="abrirAddServico">
                        <i class="fa fa-plus font-13 mr-1"></i> Adicionar
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div class="col-12" v-if="pesquisa.resultado.length > 0">
         <div class="cards">
            <servico v-for="(servico, index) in pesquisa.resultado" :key="index" :servico="servico" :index="index" 
               @feedback="abrirFeedbackServico($event)" @editar="abrirEditarServico($event)" />
			</div>
		</div>
      <div class="col-12 my-5 text-center" v-else>Nenhum resultado encontrado</div>

      <!-- modalFeedbackServico -->
      <div class="modal fade" id="modalFeedbackServico" tabindex="-1" aria-labelledby="modalFeedbackServicoLabel" aria-hidden="true">
         <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title h4" id="modalFeedbackServicoLabel" v-if="modal != null && modal.id != null">{{ dadosUsuario.usuarioEntidade == null ? 'Visualizar' : 'Editar' }} feedback</h5>
                  <h5 class="modal-title h4" id="modalFeedbackServicoLabel" v-else>Adicionar feedback</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
               </div>
               <div class="modal-body" v-if="modal != null">
                  <div class="card mb-0">
                     <div class="card-body">
                        <div class="row m-0">
                           <div class="col-xl-5 px-1 mb-3" v-if="dadosUsuario.usuarioEntidade != null">
                              <label class="mb-2"><i class="far fa-star color-theme font-13 mr-1"></i> Nota *</label>
                              <i @click="feedback = 1;" class="fas fa-star font-30 cursor-pointer mr-3" :class="feedback >= 1 ? 'text-warning' : ''"></i>
                              <i @click="feedback = 2;" class="fas fa-star font-30 cursor-pointer mr-3" :class="feedback >= 2 ? 'text-warning' : ''"></i>
                              <i @click="feedback = 3;" class="fas fa-star font-30 cursor-pointer mr-3" :class="feedback >= 3 ? 'text-warning' : ''"></i>
                              <i @click="feedback = 4;" class="fas fa-star font-30 cursor-pointer mr-3" :class="feedback >= 4 ? 'text-warning' : ''"></i>
                              <i @click="feedback = 5;" class="fas fa-star font-30 cursor-pointer" :class="feedback == 5 ? 'text-warning' : ''"></i>
                           </div>
                           <div class="col-xl-5 px-1 mb-3" v-else>
                              <label class="mb-2"><i class="far fa-star color-theme font-13 mr-1"></i> Nota *</label>
                              <i class="fas fa-star font-30 mr-3" :class="feedback >= 1 ? 'text-warning' : ''"></i>
                              <i class="fas fa-star font-30 mr-3" :class="feedback >= 2 ? 'text-warning' : ''"></i>
                              <i class="fas fa-star font-30 mr-3" :class="feedback >= 3 ? 'text-warning' : ''"></i>
                              <i class="fas fa-star font-30 mr-3" :class="feedback >= 4 ? 'text-warning' : ''"></i>
                              <i class="fas fa-star font-30" :class="feedback == 5 ? 'text-warning' : ''"></i>
                           </div>
                           <div class="col-12 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-ellipsis-h color-theme font-13 mr-1"></i> Descrição</label>
                              <textarea type="text" class="form-control shadow-none rounded" maxlength="250" v-model="modal.descricaoFeedback" :disabled="dadosUsuario.usuarioEntidade == null"></textarea>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="modal-body my-5 text-center font-16" v-else>Nenhuma informação encontrada</div>
               <div class="modal-footer">
                  <button type="button" class="btn btn-round btn-primary" @click="salvarFeedback" v-if="dadosUsuario.usuarioEntidade">Salvar</button>
                  <button type="button" class="btn btn-round btn-secondary" data-dismiss="modal">Fechar</button>
               </div>
            </div>
         </div>
      </div>

      <!-- modalServico -->
      <div class="modal fade" id="modalServico" tabindex="-1" aria-labelledby="modalServicoLabel" aria-hidden="true">
         <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title h4" id="modalServicoLabel" v-if="modal != null && modal.id != null">Editar sentença</h5>
                  <h5 class="modal-title h4" id="modalServicoLabel" v-else>Adicionar sentença</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
               </div>
               <div class="modal-body" v-if="modal != null">
                  <div class="card mb-0">
                     <div class="card-body">
                        <div class="row m-0">
                           <div class="col-xl-8 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-address-card color-theme font-13 mr-1"></i> Nº do processo *</label>
                              <input type="text" class="form-control rounded" v-model="pesquisa.docIdentificacao" @keyup.enter="buscarApenado" />
                           </div>
                           <div class="col-xl-4 px-1 mb-3 align-self-end">
                              <button class="btn btn-primary w-100 rounded" @click="buscarApenado"><i class="far fa-search mr-1"></i> Buscar</button>
                           </div>
                           <div class="col-xl-6 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-user color-theme font-13 mr-1"></i> Nome sentenciado</label>
                              <input type="text" class="form-control rounded" maxlength="200" v-model="modal.nomeApenado" disabled />
                           </div>
                           <div class="col-xl-3 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-calendar color-theme font-13 mr-1"></i> Data *</label>
                              <input type="text" class="form-control rounded" v-model="modal.data" v-mask="'##/##/####'" />
                           </div>
                           <div class="col-xl-3 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-clock color-theme font-13 mr-1"></i> Horas *</label>
                              <input type="text" class="form-control rounded" v-mask="'###############'" v-model="modal.horas" :disabled="modal != null && modal.id != null" />
                           </div>
                           <div class="col-12 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-ellipsis-h color-theme font-13 mr-1"></i> Descrição *</label>
                              <textarea type="text" class="form-control rounded shadow-none" maxlength="250" v-model="modal.descricao"></textarea>
                           </div>
                           <div class="col-8 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-address-card color-theme font-13 mr-1"></i> Nome entidade</label>
                              <input type="text" class="form-control rounded" v-model="modal.nomeEntidade" disabled/>
                           </div>
                           <div class="col-4 px-1">
                              <label class="mb-1"><i class="far fa-building color-theme font-13 mr-1"></i> CNPJ entidade</label>
                              <input type="text" class="form-control rounded" maxlength="200" v-model="modal.cnpjEntidade" disabled />
                           </div>
                           <div class="col-8 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-gavel color-theme font-13 mr-1"></i> Nº autos (Processo)</label>
                              <input type="text" class="form-control rounded" maxlength="200" v-model="modal.numeroAutos" disabled/>
                           </div>
                           <div class="col-4 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-clock color-theme font-13 mr-1"></i> Horas pendentes</label>
                              <input type="text" class="form-control rounded text-center" maxlength="200" v-model="modal.horasPendentes" disabled />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="modal-body my-5 text-center font-16" v-else>Nenhuma informação encontrada</div>
               <div class="modal-footer">
                  <button type="button" class="btn btn-round btn-primary" @click="salvarServico">Salvar</button>
                  <button type="button" class="btn btn-round btn-secondary" data-dismiss="modal">Fechar</button>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>

import $ from 'jquery'
import { mapState } from 'vuex'
import { ptBR } from 'vuejs-datepicker/dist/locale'
import servico from '@/components/sentencas/Sentenca.vue'

export default {
	name: 'Sentencas',
   data: function () {
      return {
         ptBR: ptBR,
         pesquisa: {'tipo': 'Nome sentenciado', 'nomeApenado': null, 'docIdentificacao': null, 'nomeEntidade': null, 'dataInicial': null, 'dataFinal': null, 'resultado': []},
         modal: {'id': null, 'idEntidade': null, 'idApenado': null, 'horas': null, 'descricao': null, 'docIdentificacao': null, 'nomeApenado': null, 'cnpjEntidade': null, 
            'nomeEntidade': null, 'idProcesso': null, 'numeroAutos': null, 'horasPendentes': null, 'feedback': null, 'descricaoFeedback': null, 'data': new Date().toLocaleDateString()},
         modalConfig: {'researched': false, 'processo': false, 'entidade': false},
         feedback: null,
         entidadeSelecionada: null,
         listaEntidades: []
      }
   },
   computed: {
      ... mapState({
         dadosUsuario: state => state.dadosUsuario,
         tokenSessao: state => state.tokenSessao,
         urlRest: state => state.urlRest
      })
   },
   components: {
      servico
   },
   methods: {
      buscarServicos : function () {
         let ref = this;
         let valor1 = '';
         this.$store.dispatch('alternarTelaCarregamento', true)

			switch (this.pesquisa.tipo) {
				case 'Nome entidade':
					valor1 = this.pesquisa.nomeEntidade
				break;
				case 'Nº Documento de Identificação':
					valor1 = this.pesquisa.docIdentificacao
				break;
				case 'Data':
					valor1 = window.innerWidth < 767 ? this.pesquisa.dataInicial : this.pesquisa.dataInicial.getFullYear() +'-'+ (this.pesquisa.dataInicial.getMonth() + 1) +'-'+ this.pesquisa.dataInicial.getDate()
				break;
				default:
					valor1 = this.pesquisa.nomeApenado
				break;
			}

         this.$axios({
            method: 'get',
            url: this.urlRest +'servicos/searchServicos',
            params: {
               tipo: this.pesquisa.tipo,
               idEntidade: this.dadosUsuario.usuarioEntidade,
               valor1: valor1,
               valor2: window.innerWidth < 767 ? this.pesquisa.dataFinal : this.pesquisa.dataFinal.getFullYear() +'-'+ (this.pesquisa.dataFinal.getMonth() + 1) +'-'+ this.pesquisa.dataFinal.getDate()
            }
         }).then(response => {
				this.pesquisa.resultado = response.data

         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      buscarApenado : function () {
         let ref = this;
         this.$store.dispatch('alternarTelaCarregamento', true)

         this.$axios({
            method: 'get',
            url: this.urlRest +'apenados/getByNumeroProcesso',
            params: {
               numeroProcesso: this.pesquisa.docIdentificacao,
               isProcesso: true
            }
         }).then(response => {
            if (response.data != null) {
               ref.modal.docIdentificacao = response.data.docIdentificacao;
               ref.modal.nomeApenado = response.data.nomeCompleto;
               ref.modal.idApenado = response.data.id;
               ref.modalConfig.researched = true;

               ref.modal.numeroAutos = response.data.numeroProcesso;
               ref.modal.idProcesso = response.data.idProcesso;
               ref.modal.horasPendentes = response.data.processo.horasPendentes;

               if (response.data.entidade != null) {
                  ref.modalConfig.entidade = true;
                  ref.modal.nomeEntidade = response.data.entidade.nome;
                  ref.modal.cnpjEntidade = response.data.entidade.cnpj;
                  ref.entidadeSelecionada = response.data.entidade.nome;
                  ref.modal.idEntidade = response.data.entidade.id;
               } else {
                  ref.modal.cnpjEntidade = null;
                  ref.modal.nomeEntidade = null;
                  ref.modal.idEntidade = null;
               }
            }
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else if (error.response.status == 400) {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Sentenciado não encontrado!'
                  });


               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      buscarEntidade : function () {
         let ref = this;
         this.$store.dispatch('alternarTelaCarregamento', true)

         this.$axios({
            method: 'get',
            url: this.urlRest +'entidades/getEntidade',
            params: {
               nome: this.entidadeSelecionada.nome
            }
         }).then(response => {
            if (response.data != null) {
               ref.modalConfig.entidade = true;
               ref.modal.cnpjEntidade = response.data.cnpj;
               ref.modal.nomeEntidade = response.data.nome;
               ref.modal.idEntidade = response.data.id;
            }
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else if (error.response.status == 400) {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Entidade não encontrada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      buscarProcesso : function () {
         let ref = this;
         this.$store.dispatch('alternarTelaCarregamento', true)

         this.$axios({
            method: 'get',
            url: this.urlRest +'processos/getProcesso',
            params: {
               numeroAutos: this.modal.numeroAutos
            }
         }).then(response => {
            if (response.data != null) {
               ref.modalConfig.processo = true;
               ref.modal.idProcesso = response.data.id;
               ref.modal.horasPendentes = response.data.horasPendentes;
               ref.modal.numeroAutos = response.data.numeroAutos;
            }
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else if (error.response.status == 400) {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Entidade não encontrada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      abrirFeedbackServico : function (servico) {
         this.modal = JSON.parse(JSON.stringify(servico))
         this.feedback = servico.feedback;

         setTimeout(() => {
            $('#modalFeedbackServico').modal('show')
         }, 100);
      },
      abrirAddServico : function () {
         this.modal = {'id': null, 'idEntidade': null, 'idApenado': null, 'horas': null, 'descricao': null, 'docIdentificacao': null, 'nomeApenado': null, 'cnpjEntidade': null, 
            'nomeEntidade': null, 'idProcesso': null, 'numeroAutos': null, 'horasPendentes': null, 'feedback': null, 'descricaoFeedback': null, 'data': new Date().toLocaleDateString()}
         this.modalConfig = {'researched': false, 'processo': false, 'entidade': false}
         this.pesquisa.docIdentificacao = null;

         setTimeout(() => {
            $('#modalServico').modal('show')
         }, 100);
      },
      abrirEditarServico : function (servico) {
         this.modal = JSON.parse(JSON.stringify(servico));
         this.modalConfig = {'researched': true, 'processo': true, 'entidade': true};
         this.modal.data = new Date(servico.data.year +'/'+ servico.data.monthValue +'/'+ servico.data.dayOfMonth).toLocaleDateString();
         this.entidadeSelecionada = this.modal.nomeEntidade;
         this.pesquisa.docIdentificacao = this.modal.numeroAutos;
         
         setTimeout(() => {
            $('#modalServico').modal('show')
         }, 100);
      },
      salvarServico : function () {
         if (this.modal.descricao == null || this.modal.descricao.trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Descrição inválida!'
            })

            return
         } else if (this.modal.horas == null || String(this.modal.horas).trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Hora(s) inválida(s)!'
            })

            return
         } else if (this.modal.idApenado == null) {
            this.$toast.fire({
               icon: 'error',
               title: 'Sentenciado inválido!'
            })

            return
         } else if (this.modal.idEntidade == null) {
            this.$toast.fire({
               icon: 'error',
               title: 'Entidade inválida!'
            })

            return
         }

         let ref = this;
			this.$store.dispatch('alternarTelaCarregamento', true)

         this.$axios({
            method: 'post',
            url: this.urlRest +'servicos/saveServico',
            headers: {
					'Content-Type': 'application/json'
            },
				data: this.modal

         }).then(function () {
				$('#modalServico').modal('hide')
            ref.pesquisa.resultado = [];
            
            ref.$toast.fire({
               icon: 'success',
               title: 'Servico salvo!'
            })
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else if (error.response.status == 400) {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Nenhum processo encontrado!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  })
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               })
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         })
      },
      salvarFeedback : function () {
         if (this.feedback == null || String(this.feedback).trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Descrição inválida!'
            })

            return
         }

         let ref = this;
			this.$store.dispatch('alternarTelaCarregamento', true)
         this.modal.feedback = this.feedback;

         this.$axios({
            method: 'post',
            url: this.urlRest +'servicos/feedbackServico',
            headers: {
					'Content-Type': 'application/json'
            },
				data: this.modal

         }).then(function () {
				$('#modalFeedbackServico').modal('hide')
            ref.pesquisa.resultado = [];

            ref.$toast.fire({
               icon: 'success',
               title: 'Feedback salvo!'
            })
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  })
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               })
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         })
      },
      calcularData : function () {
         this.$store.dispatch('buscarInicioSemana', new Date()).then((domingo) => {
            let sabado = new Date(new Date(domingo).setDate(domingo.getDate() + 6));

            if (window.innerWidth < 767) {
               let zeroFill = n => {
                  return ('0' + n).slice(-2);
               }

               this.pesquisa.dataInicial = domingo.getFullYear() +'-'+ zeroFill((domingo.getMonth() + 1)) +'-'+ zeroFill(domingo.getDate());
               this.pesquisa.dataFinal = sabado.getFullYear() +'-'+ zeroFill((sabado.getMonth() + 1)) +'-'+ zeroFill(sabado.getDate());

            } else {
               this.pesquisa.dataInicial = domingo;
               this.pesquisa.dataFinal = sabado;
            }
			})
      },
      searchAllEntidades : function () {
         let ref = this;

         this.$store.dispatch('alternarTelaCarregamento', true)
         this.$axios({
            method: 'get',
            url: this.urlRest +'entidades/searchAllEntidades',

         }).then(response => {
				this.listaEntidades = response.data

         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
   },
   mounted() {
      this.calcularData()
      this.searchAllEntidades()

      let ref = this;
      $(window).resize(function(){
         ref.calcularData()
      });

      $('#search-nav .dropdown-menu').on('click', function(e) {
         if (e.target.nodeName != 'BUTTON') {
            e.stopPropagation();
         }
      });
   }
}

</script>